module.exports = require("@seddi/three/examples/jsm/shaders/GammaCorrectionShader.js");